import { renderCustomComponent } from 'components/ChatWidget';
import { MESSAGE_TYPE_BOT, MESSAGE_TYPE_USER } from 'constant/chat';
import moment from 'moment';

interface TimeStampProps {
    messageType: typeof MESSAGE_TYPE_BOT | typeof MESSAGE_TYPE_USER;
    timeStamp: Date;
}

const DisplayMessageTimeStamp = ({ messageType, timeStamp }: TimeStampProps) => {
    const className = messageType === MESSAGE_TYPE_USER ? 'rcw-client rcw-timestamp' : 'rcw-timestamp';

    return renderCustomComponent(() => <div className={className}>{moment(timeStamp).format('hh:mm a')}</div>, {});
};

export default DisplayMessageTimeStamp;
